export default {
  "mzk-logo-src": {
    "cs": "img/mzk-logo.png",
    "en": "img/mzk-logo-en.png"
  },
  "title": {
    "cs": "MapSeries",
    "en": "MapSeries"
  },
  "subtitle": {
    "cs": "Katalogizace listů mapových děl",
    "en": "Cataloguing of Map Series"
  },
  "search-label": {
    "cs": "Hledat místo na mapě:",
    "en": "Find a place on the map:"
  },
  "tab-main": {
    "cs": "Seznam",
    "en": "Serie"
  },
  "tab-about": {
    "cs": "Mapová díla",
    "en": "Map Series"
  },
  "tab-help": {
    "cs": "Nápověda",
    "en": "Help"
  },
  "choose-serie": {
    "cs": "Vybrat mapové dílo:",
    "en": "Choose a map serie:"
  },
  "filter-region": {
    "cs": "Filtr podle regionu:",
    "en": "Filter by region:"
  },
  "filter-grid": {
    "cs": "Klad listů:",
    "en": "Grid:"
  },
  "admin": {
    "cs": "Admin",
    "en": "Admin"
  },
  "sheet-detail": {
    "cs": "Šablona listu pro Aleph",
    "en": "Sheet template for Aleph"
  },
  "copy-to-clipboard": {
    "cs": "Zkopírovat do schránky",
    "en": "Copy to clipboard"
  },
  "copy-to-clipboard-008": {
    "cs": "Zkopírovat pole 008 do schránky",
    "en": "Copy 008 to clipboard"
  },
  "copy-to-clipboard-arl": {
    "cs": "Zkopírovat do schránky ve formátu ARL",
    "en": "Copy ARL to clipboard"
  },
  "mapseries-online": {
    "cs": "Map Series: Mapová díla online",
    "en": "Map Series: Online"
  },
  "scale-calculator": {
    "cs": "Výpočet měřítka",
    "en": "Scale calculator"
  },
  "authors": {
    "cs": "Autoři",
    "en": "Authors"
  },
  "openstreetmap": {
    "cs": "OpenStreetMap",
    "en": "OpenStreetMap"
  },
  "close": {
    "cs": "Zavřít",
    "en": "Close"
  },
  "input-hint": {
    "cs": "Vybrat nebo napsat hodnotu...",
    "en": "Select or type another value..."
  },
  "authority-hint": {
    "cs": "Vybrat hodnotu nebo napsat část názvu a vybrat z Národních autorit ČR...",
    "en": "Select a value or type a part of the name to choose from the Czech National Authority File..."
  },
  "authority-results": {
    "cs": "Národní autority ČR:",
    "en": "Czech National Authority File:"
  },
  "authority-none": {
    "cs": "V Národních autoritách ČR nic nenalezeno",
    "en": "Nothing found in the Czech National Authority File"
  },
  "check-ok": {
    "cs": "Zkopírováno.",
    "en": "Copied."
  },
  "check-problems": {
    "cs": "Zkopírováno, ale záznam má chyby – opravte je v šabloně (nebo v Alephu):",
    "en": "Copied, but the record has errors – fix them in the template (or in Aleph):"
  },
  "check-008": {
    "cs": "Pole 008 má {0} znaků místo 40",
    "en": "Field 008 has {0} characters instead of 40"
  },
  "check-008-empty": {
    "cs": "nevyplněno: {0}",
    "en": "not filled in: {0}"
  },
  "check-no-corporation": {
    "cs": "Není vybrána korporace (110)",
    "en": "No corporation chosen (110)"
  },
  "check-empty-field": {
    "cs": "Prázdné pole {0} – v Alephu ho smažte",
    "en": "Empty field {0} – delete it in Aleph"
  },
  "check-no-code": {
    "cs": "Pole {0} „{1}“ nemá kód autority $7",
    "en": "Field {0} \"{1}\" has no authority code $7"
  },
  "check-no-indicator": {
    "cs": "Pole {0} „{1}“ nemá indikátor",
    "en": "Field {0} \"{1}\" has no indicator"
  },
  "check-no-publisher": {
    "cs": "Chybí místo vydání a nakladatel ({0})",
    "en": "Place of publication and publisher missing ({0})"
  },
  "check-no-dimensions": {
    "cs": "Chybí rozměry mapy (300 $c)",
    "en": "Map dimensions missing (300 $c)"
  },
  "check-no-title": {
    "cs": "Chybí název listu (245 $a)",
    "en": "Sheet title missing (245 $a)"
  },
  "template-add": {
    "cs": "+ přidat do šablony",
    "en": "+ add to the template"
  },
  "template-add-hint": {
    "cs": "Tato hodnota v šabloně není. Otevře editor šablony (po přihlášení) s připraveným řádkem ke kontrole a uložení.",
    "en": "The template does not have this value. Opens the template editor (after a login) with the row prepared to check and save."
  },
  "authority-only": {
    "cs": "Hodnotu nelze napsat ručně – vyberte ji ze šablony nebo z Národních autorit ČR (napište část názvu).",
    "en": "The value cannot be typed in – choose it from the template or from the Czech National Authority File (type a part of the name)."
  }
}
